import { mapEvent } from '~/components/Events/mapEvent'

export default (block) => {
  block.mappedEvent = mapEvent(block.event)

  return block
}
